<template>
    <div class="page-list">
        <form action="" @submit="e => e.preventDefault()">
            <van-search v-model="state.keyword" show-action placeholder="请输入企业名称或关键词" enterkeyhint="search"
                @search="onSearch" @cancel="onCancel" />
        </form>
        <van-list ref="list" v-model:loading="state.loading" :finished="state.finished"
            :finished-text="state.finished && state.list.length > 0 ? '没有更多了' : ''" @load="onLoad">
            <img class="tips" src="https://kdmvp.oss-cn-shanghai.aliyuncs.com/sh_keep_supply/images/banner-mini.png">
            <template v-for="(item, index) in state.list" :key="item.id">
                <router-link :to="{ name: 'detail', query: { enterprise: item.name } }" custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <div class="row" @click="navigate">
                        <div class="left">
                            <div class="name two-line-ellipsis">{{ item.name }}</div>
                            <span class="category"
                                :style="{ color: 'rgba(' + item.categoryTagColor + ', 1)', borderColor: 'rgba(' + item.categoryTagColor + ', 0.54)', backgroundColor: 'rgba(' + item.categoryTagColor + ', 0.24)' }">{{
                                    item.categoryName
                                }}</span>
                        </div>
                        <div class="right">查看证明 ></div>
                    </div>
                </router-link>
                <!-- <div class="row" @click="handleRow(item)">
                    <div class="left">
                        <div class="name two-line-ellipsis">{{ item.name }}</div>
                        <span class="category"
                            :style="{ color: 'rgba(' + item.categoryTagColor + ', 1)', borderColor: 'rgba(' + item.categoryTagColor + ', 0.54)', backgroundColor: 'rgba(' + item.categoryTagColor + ', 0.24)' }">{{
                                item.categoryName
                            }}</span>
                    </div>
                    <div class="right">查看证明 ></div>
                </div> -->
            </template>
            <img class="empty" src="https://kdmvp.oss-cn-shanghai.aliyuncs.com/sh_keep_supply/images/noresult.png"
                v-show="state.finished && state.list.length === 0" />
        </van-list>
    </div>
</template>
<style lang="scss" scoped>
@import "../styles/list.scss";
</style>
<script>
import { ref, reactive, computed, onMounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getList, statistics } from '@/api/service'

export default {
    setup() {
        const { query } = useRoute()
        const { id, name } = query
        document.title = name
        const state = reactive({
            keyword: '',
            page: 1,
            limit: 20,
            list: [],
            loading: false,
            finished: false
        })
        const list = ref(null)
        const requestList = () => {
            getList({
                categoryId: id,
                keyword: state.keyword,
                page: state.page,
                limit: state.limit
            }).then(response => {
                let list = response.data
                if (list.length > 0) {
                    state.list = [...state.list, ...list]
                    state.page++
                } else {
                    state.finished = true
                }
                state.loading = false
            }).catch(error => {
                console.error(error)
            })
        }
        statistics({ categoryId: parseInt(id) })
        const onLoad = () => {
            requestList()
        }
        const onSearch = keyword => {
            console.log('onSearch', state.keyword)
            state.keyword = keyword
            state.page = 1
            state.list = []
            state.finished = false
            list.value.check()
            statistics({ categoryId: -2 })
        }
        const onCancel = () => {
            console.log('onCancel', state.keyword)
            state.keyword = ''
            state.page = 1
            state.list = []
            state.finished = false
            list.value.check()
        }
        return {
            state,
            list,
            onLoad,
            onSearch,
            onCancel
        }
    },
    methods: {
        handleRow(item) {
            this.$dialog.confirm({
                title: '证明文件下载方式',
                message: '1、iOS用户：\n步骤一： 点击【确认】按钮，进入PDF文件查看页面；\n步骤二：复制文件链接，在手机浏览器中打开并下载\n2、安卓用户：点击【确认】按钮，即可下载',
                messageAlign: 'left',
                confirmButtonColor: '#0B3A96'
            }).then(() => {
                window.location.href = item.fileUrl
            }).catch(() => {
            })
        }
    }
}
</script>